import React from "react";
import { Breadcrumbs, Typography } from "@material-ui/core";
import { BreadCrumsContainer, BreadcrumbLink } from "./index";

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
  return (
    <BreadCrumsContainer>
      <Breadcrumbs aria-label="breadcrumb">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          if (isLast || !item.href) {
            return (
              <Typography key={index} color="textPrimary">
                {item.label}
              </Typography>
            );
          }

          return (
            <BreadcrumbLink key={index} color="inherit" href={item.href}>
              {item.label}
            </BreadcrumbLink>
          );
        })}
      </Breadcrumbs>
    </BreadCrumsContainer>
  );
};
